import React from 'react';

import T from '../common/translation';

function OfferCardLoading(props) {
  return (
    <div className="offer-card offer-card--loading">
      <div className="offer-card__header">
        <img
          className="offer-card__img"
          src={require('../../assets/key-generic.png')}
        />
      </div>
      <div className="offer-card__name">█████</div>

      <div className="offer-card__line">
        <div className="offer-card__line-title">{T('brand')}</div>
        <span>████████</span>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">{T('description')}</div>
        <span>
          █████████████████
          <br />
          █████████████████
          <br />
          █████████
        </span>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">{T('delay')}</div>
        <span>███████</span>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">Prix</div>
        <span className="offer-card__price">████████</span>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">
          {T('safety index')}
        </div>
        <div className="meter">
          <div className="meter__grad meter__grad--loading">1</div>
          <div className="meter__grad meter__grad--loading">2</div>
          <div className="meter__grad meter__grad--loading">3</div>
          <div className="meter__grad meter__grad--loading">4</div>
          <div className="meter__grad meter__grad--loading">5</div>
          <div className="meter__score">3/5</div>
        </div>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">
          {T('EN1303 norme')}
        </div>
        <p>█████████████</p>
      </div>
      <div className="offer-card__line">
        <div className="offer-card__line-title">
          {T('protection')}
        </div>
        <p>
          ██████ ████████
          <br />
          ████████ ████
        </p>
      </div>
      <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
        <button className="button button--primary button--large button--disabled">
          {T('choose')}
        </button>
      </div>
    </div>
  );
}

export default OfferCardLoading;



// WEBPACK FOOTER //
// ./src/js/offer/OfferCardLoading.js